import { defaultValue, SternumTheme } from '@sternum/ui';

import { Colors } from '../constants';

export const darkTheme: SternumTheme = {
  ...defaultValue,
  primary: Colors.BrandPink,
  secondary: Colors.BrandBlue,
  focusColor: Colors.AquaMiddle,
  textColor: Colors.White,
  fontFamily: 'Fellix, Arial, Helvetica, sans-serif',
};
